import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.269 18.5 1.05 14.278a1.03 1.03 0 0 1 0-1.453L11.217 2.658a1.03 1.03 0 0 1 1.453 0l5.447 5.447a1.03 1.03 0 0 1 0 1.452L9.23 18.444m-4.549-9.25 6.899 6.9M.75 21.498h4.5m7.5 0h1.5m3 0h1.5m3 0h1.5m-15 0h1.5"
    }, null, -1)
  ]));
}
const interfaceEditToolEraser = { render };
export {
  interfaceEditToolEraser as default,
  render
};
//# sourceMappingURL=interface-edit-tool-eraser.svg.js.map
